export const orderActionTypes = {
  START_ADD_ORDER: "START_ADD_ORDER",
  ADD_ORDER_SUCCESS: "ADD_ORDER_SUCCESS",
  ADD_ORDER_FAILURE: "ADD_ORDER_FAILURE",

  START_FETCH_ORDERS: "START_FETCH_ORDERS",
  FETCH_ORDERS_SUCCESS: "FETCH_ORDERS_SUCCESS",
  FETCH_ORDERS_FAILURE: "FETCH_ORDERS_FAILURE",

  CLEAR_ORDERS: "CLEAR_ORDERS",
};
